export default "__VITE_ASSET__BKsc4nMT__"